import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { FormCode } from "../..";

@Injectable()
export class FormCodeService extends BaseDataService<FormCode> {
  constructor(http: HttpService) {
    super(http, "formcode");
  }

  createInstance(options: any): FormCode {
    return new FormCode(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
